import { RobotIcon } from './RobotIcon';

/**
 * author: GreenTurtwig
 * id EC6C8D3D-0315-4C3A-B37A-97411758DF34
 * name robot
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot.svg
 * tags
 * - Home Automation 
 */
export const EmojiRobotIcon = RobotIcon;
export default EmojiRobotIcon